// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"299":"43f2b913","305":"d29edcbe","355":"25f5cda8","684":"56f79cac","967":"a7a6ea69"}[chunkId] + ".chunk.css";
};